import { makeStyles } from "@mui/styles";
import { COLORS } from "@constants";

const useStyles = makeStyles(() => ({
  container: {
    fontFamily: "sans-serif",
    padding: "1.5rem",
  },
  cardTitle: {
    color: "#fff",
    fontSize: "1.3rem",
    fontWeight: "bold",
    width: "100%",
  },
  contactLabels: {
    fontSize: "1rem",
    fontFamily: "Roboto,sans-serif",
    fontWeight: 400,
    color: "#8a8a92",
    "& div": {
      paddingTop: "1rem",
    },
  },
  contactValues: {
    fontSize: "1rem",
    fontFamily: "Roboto,sans-serif",
    color: "#fff",
    fontWeight: "bold",
    "& div": {
      paddingTop: "1rem",
    },
  },
  showMoreButton: {
    backgroundColor: "transparent",
    border: `2px solid ${COLORS.main}`,
    borderRadius: "50px",
    transition: "all .15s ease-in-out",
    color: COLORS.main,
    marginLeft: 12,
    "&:hover": {
      boxShadow: `0 0 10px 0 ${COLORS.main} inset, 0 0 20px 2px ${COLORS.main}`,
      border: `2px solid ${COLORS.main}`,
    },
  },
}));

export { useStyles };
